const AVAILABLE_THEMES_CLASS_NAMES: string[] = ['dark', 'beneath-header', 'gradient-header', 'blur-header'];
let appliedThemesClassNames: string[] = [];
let isAppliedThemesClassNamesFetched = false;

function getAppliedThemeClassNames(): string[] {
  const themeClassNames: string[] = [];

  AVAILABLE_THEMES_CLASS_NAMES.forEach((className) => {
    if (document.body.classList.contains(className)) {
      themeClassNames.push(className);
    }
  });

  isAppliedThemesClassNamesFetched = true;

  return themeClassNames;
}

export const removeThemeClassNames = (): void => {
  if (!isAppliedThemesClassNamesFetched) {
    appliedThemesClassNames = getAppliedThemeClassNames();
  }

  appliedThemesClassNames.forEach((className) => document.body.classList.remove(className));

  if (appliedThemesClassNames.includes('beneath-header')) {
    document.body.classList.add('nav-opened');
  }

  if (appliedThemesClassNames.includes('dark')) {
    document.body.classList.add('dark-header-promo');
  }
};

export const addThemeClassNames = (): void => {
  appliedThemesClassNames.forEach((className) => document.body.classList.add(className));
  if (appliedThemesClassNames.includes('beneath-header')) {
    document.body.classList.remove('nav-opened');
  }

  if (appliedThemesClassNames.includes('dark')) {
    document.body.classList.remove('dark-header-promo');
  }
};
